import { memo, useMemo } from "react";
import { Area, AreaChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { formatLocalTime, formatNumber, throughputUnit } from "../../lib/format";

/* 디자인: 파란 선 + 아래로 옅어지는 영역, 눈금 #98A8BF */
const LINE = "#4E8DF5";
const TICK = { fill: "#98A8BF", fontSize: 11 };

function TooltipBox({ active, payload }) {
    if (!active || !payload?.length)
        return null;
    const row = payload[0].payload;
    return (<div className="dfv-chart-tip">
      <div>{row.label}</div>
      <b>{formatNumber(row.v, row.v >= 100 ? 0 : 1)}</b>
    </div>);
}

/** 최근 60점 처리량 Area 차트. 고정 높이·애니메이션 off (5초마다 갱신되므로). */
export const ThroughputChart = memo(function ThroughputChart({ history, nodeType, height = 150 }) {
    const rows = useMemo(() => history.map((h) => ({ t: h.t, label: formatLocalTime(h.t), v: Number.isFinite(h.v) ? h.v : 0 })), [history]);
    const unit = throughputUnit(nodeType);
    if (rows.length < 2) {
        return (<div className="dfv-chart-empty" style={{ height }} role="img" aria-label="처리량 추이: 데이터 수집 중">
        처리량 추이 수집 중… ({rows.length}/60)
      </div>);
    }
    return (<div style={{ height }} role="img" aria-label={`최근 처리량 추이 (${unit}), ${rows.length}점`}>
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={rows} margin={{ top: 8, right: 8, bottom: 0, left: 0 }}>
          <defs>
            <linearGradient id="dfv-tp-grad" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor={LINE} stopOpacity={0.4}/>
              <stop offset="100%" stopColor={LINE} stopOpacity={0.03}/>
            </linearGradient>
          </defs>
          <CartesianGrid stroke="rgba(255,255,255,0.06)" vertical={false}/>
          <XAxis dataKey="label" tick={TICK} tickLine={false} axisLine={false} minTickGap={40} interval="preserveStartEnd"/>
          <YAxis width={30} tick={TICK} tickLine={false} axisLine={false} allowDecimals={false} domain={[0, "auto"]}/>
          <Tooltip content={<TooltipBox />} cursor={{ stroke: "rgba(197,215,224,0.35)", strokeWidth: 1 }} isAnimationActive={false}/>
          <Area type="monotone" dataKey="v" stroke={LINE} strokeWidth={1.5} fill="url(#dfv-tp-grad)" isAnimationActive={false} dot={false} activeDot={{ r: 3, strokeWidth: 0 }}/>
        </AreaChart>
      </ResponsiveContainer>
    </div>);
});
